import React, { Component } from "react";
import YesNoDialog from "./YesNoDialog";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/fontawesome-free-solid";
import ReactLoading from "react-loading";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imgcolumn: [],
      column1: [],
      column2: [],
      column3: [],
      column4: [],
      activeURL: "",
      showSaveDialog: false,
      updateStarted: false,
      rejectStatus: null,
      approvedStatus: null
    };
    this.mouseHandler = this.mouseHandler.bind(this);
    this.rejectEntry  = this.rejectEntry.bind(this);
  }

  mouseHandler(e) {
    var clicked_image = document.getElementsByClassName("imgthumb" + e.target.id)[0];
    this.props.setActiveImage(clicked_image.getAttribute('src'));
  }

  rejectEntry(e) {
    var clicked_image = document.getElementById(e.target.id);
    this.setState({ showSaveDialog: clicked_image.getAttribute('id') });
    e.stopPropagation();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.active_filter_button !== this.props.active_filter_button) {
      this.props.filterEntries(this.props.active_filter_button);
    }

    if(prevState.rejectStatus !== this.state.rejectStatus){
      this.props.filterEntries(this.props.active_filter_button);
    }

    if (prevProps.images.approvedStatus !== this.state.approvedStatus) {
      this.props.filterEntries(this.props.active_filter_button)
    }

    if (prevProps.images !== this.props.images) {
      this.updateArray();
    } 
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.images.rejectStatus === "success") {
      this.setState({ rejectStatus: "success", updateStarted: false })
    }
    if(nextProps.images.approvedStatus === "success") {
      this.setState({ approvedStatus: "success" })
    }
  }

  componentWillMount() {
    if (this.props.images.status) this.updateArray();
    
  }

  updateArray() {
    var imgcolumnData = [];
    var column1Data = [];
    var column2Data = [];
    var column3Data = [];
    var column4Data = [];
    //newest image should come first.
    //so that images state data is reversed before returning image element
    if(this.props.images.data){
      this.props.images.data
        .slice(",")
        .reverse()
        .map((data, index) => {
          var url = "https://s3-ap-southeast-1.amazonaws.com/nigoki-dev/" + data.entryImg;
          var imgElemStat = "";
          if(this.props.currentLocation==="moderation"){
            imgElemStat = (data.entryStatus===1) ? 'approved' : ((data.entryStatus===2) ? "rejected" : "");  
          }
          var imgElement = (
            <div className={"entry-thumb " + "imgthumb" + index + " " + imgElemStat }
                  src={url}
                  id={index}
                  key={index}
                  onClick={this.mouseHandler}>
              { (data.entryStatus!==2 && this.props.currentLocation==="moderation") ? 
                (<div className="xicon" id={data._id} onClick={this.rejectEntry}>
                <FontAwesomeIcon icon={faTimes} size="1x" />
                </div>) : null }
              <img
                src={url}
                alt="random"
                style={{ width: "100%" }}
                className="z-depth-2"
              />
            </div>
          );
          imgcolumnData.push(imgElement)
        });
        this.setState({
          imgcolumn: imgcolumnData,
        });
    }
  }
  renderImages() {
    return (
      <div>
      <div className={"image_grid_row" + (this.props.currentLocation==='moderation' ? ' moderation-page' : '')}>
        {this.state.imgcolumn}
      </div>
      { this.props.currentLocation !=='moderation' ? (<div className="bottom-content hide-on-med-and-up"></div>) : null }
    </div>
    );
  }

  render() {
    return (
      <div className="col l7 m6 s12 push-l3 push-m4">
        <div className="n-dialog-reject">
        {this.state.showSaveDialog ? (
        <YesNoDialog
              question="Are you sure you want to unapprove this photo?"
              handleOnClickYes={() => {
                this.setState({ updateStarted: true, showSaveDialog: false, rejectStatus: null },
                  this.props.rejectEntry(this.state.showSaveDialog),
                )
                }
              }
              handleOnClickNo={() =>
                this.setState({ showSaveDialog: false })
              }
            />
        ) : null}
        </div>

        {this.state.updateStarted ? (
              <ReactLoading
                className="canvas-loading"
                type={"spinningBubbles"}
                color={"yellow"}
              />
        ) : null}

        {this.renderImages()}
        <div id="footer-adjustment" className="" />
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js